define('ItemRelations.Correlated.Collection.Fix', [
    'ItemRelations.Correlated.Collection',
    'underscore'
], function ItemRelationsCorrelatedCollectionFix(
    ItemRelationsCorrelatedCollection,
    _
) {
    'use strict';

    _.extend(ItemRelationsCorrelatedCollection.prototype, {
        fetchItems: _.wrap(ItemRelationsCorrelatedCollection.prototype.fetchItems, function fetchItemExtend(fn) {
            var results = fn.apply(this, _.toArray(arguments).slice(1));
            results.fail(function failFetch(jqXhr) {
                jqXhr.preventDefault = true;
            });
            return results;
        })
    });
});

